const SITE_URL = "https://spireinclusion.co.uk";

const META = {
  "/": {
    title: "Spire Inclusion | Weekday Day Support for Young Adults in Salisbury",
    description:
      "Spire Inclusion provides active, person-centred weekday day support in Salisbury for young adults with disabilities — building skills, confidence and connection.",
  },
  "/about": {
    title: "About Us | Spire Inclusion",
    description:
      "Learn about Spire Inclusion — our story, our values of respect, independence and belonging, and the friendly team behind our Salisbury day service.",
  },
  "/what-we-do": {
    title: "What We Do | Activities & Days Out | Spire Inclusion",
    description:
      "From cooking and life skills to sport, creative sessions and days out — see the activities young adults enjoy each week at Spire Inclusion in Salisbury.",
  },
  "/a-typical-week": {
    title: "A Typical Week | Our Timetable | Spire Inclusion",
    description:
      "See what a typical Monday-to-Friday week looks like at Spire Inclusion, including our daily timetable of activities, life skills and community trips.",
  },
  "/how-we-support-people": {
    title: "How We Support People | Spire Inclusion",
    description:
      "Discover our person-centred approach — how Spire Inclusion supports each young adult with individual plans, working in partnership with families and professionals.",
  },
  "/families-and-carers": {
    title: "Families & Carers | Spire Inclusion",
    description:
      "Information for families and carers — how referrals work, what to expect, funding, and answers to common questions about Spire Inclusion's day service.",
  },
  "/safeguarding-and-complaints": {
    title: "Safeguarding & Complaints | Spire Inclusion",
    description:
      "How Spire Inclusion keeps people safe — our safeguarding commitments, how to raise a concern, and our complaints procedure.",
  },
  "/careers": {
    title: "Careers | Join Our Team | Spire Inclusion",
    description:
      "Join a team that makes a difference. See current recruitment status and find out how to apply for support roles at Spire Inclusion in Salisbury.",
  },
  "/contact": {
    title: "Contact Us | Make an Enquiry | Spire Inclusion",
    description:
      "Get in touch with Spire Inclusion — send an enquiry about our day service, visits, referrals or careers. We aim to reply within two working days.",
  },
  "/news": {
    title: "News & Updates | Spire Inclusion",
    description:
      "The latest news, photos and updates from Spire Inclusion — what our members have been up to in and around Salisbury.",
  },
  "/gallery": {
    title: "Photo Gallery | Spire Inclusion",
    description:
      "Browse happy moments from Spire Inclusion — activities, days out and life skills sessions with the young adults we support in Salisbury.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Spire Inclusion",
    description:
      "How Spire Inclusion collects, uses and protects your personal information, and your rights under UK data protection law.",
  },
  "/cookie-policy": {
    title: "Cookie Policy | Spire Inclusion",
    description:
      "Details of the cookies used on the Spire Inclusion website, what they do, and how you can manage your cookie preferences.",
  },
  "/accessibility-statement": {
    title: "Accessibility Statement | Spire Inclusion",
    description:
      "Our commitment to an accessible website for everyone — how we meet WCAG 2.2 AA and how to tell us about any accessibility problems.",
  },
  "/easy-read": {
    title: "Easy Read | About Spire Inclusion",
    description:
      "An Easy Read guide to Spire Inclusion — simple words and pictures explaining what we do and how to get in touch.",
  },
};

const ensureMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const ensureCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function setPageMeta({ title, description, path, noindex = false }) {
  document.title = title;
  ensureMeta("name", "description", description);
  ensureMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  ensureMeta("property", "og:title", title);
  ensureMeta("property", "og:description", description);
  ensureMeta("property", "og:url", SITE_URL + path);
  ensureCanonical(SITE_URL + path);
}

export function applyRouteMeta(pathname) {
  const meta = META[pathname];
  if (meta) {
    setPageMeta({ ...meta, path: pathname });
  } else if (pathname.startsWith("/news/")) {
    setPageMeta({ ...META["/news"], path: pathname });
  } else {
    setPageMeta({
      title: "Page Not Found | Spire Inclusion",
      description: "Sorry, we could not find that page on the Spire Inclusion website.",
      path: pathname,
      noindex: true,
    });
  }
}
